import { useEffect, useMemo, useRef } from 'react';
import { createBarcodeScannerHandler, createScannerDiagnostics } from './barcode-scanner';

export const useBarcodeScanner = (onScanBarcode, options = {}) => {
  const callbackRef = useRef(onScanBarcode);
  const disabledRef = useRef(options.disabled);

  callbackRef.current = onScanBarcode;
  disabledRef.current = options.disabled;

  const diagnostics = useMemo(
    () =>
      options.diagnostics ||
      createScannerDiagnostics({
        enabled: false,
      }),
    [options.diagnostics],
  );
  const scanOptionsKey = JSON.stringify(options.scanOptions || {});
  const scanOptions = useMemo(() => options.scanOptions || {}, [scanOptionsKey]);

  useEffect(() => {
    const handleKeyDown = createBarcodeScannerHandler({
      onScanBarcode: code => callbackRef.current(code),
      shouldIgnoreScan: () => !!disabledRef.current,
      diagnostics,
      options: scanOptions,
    });

    window.addEventListener('keydown', handleKeyDown, true);
    return () => window.removeEventListener('keydown', handleKeyDown, true);
  }, [diagnostics, scanOptions]);
};
